import { render, staticRenderFns } from "./ResetSecretQuestion.vue?vue&type=template&id=7a0f9ec6&scoped=true&"
import script from "./ResetSecretQuestion.vue?vue&type=script&lang=js&"
export * from "./ResetSecretQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ResetSecretQuestion.vue?vue&type=style&index=0&id=7a0f9ec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0f9ec6",
  null
  
)

export default component.exports